//mega-menu header 
let items = document.querySelector(".header__inline-menu").querySelectorAll("details") || null;
  if(items){
      items.forEach(item => {
       item.addEventListener("mouseover", () => {
        item.setAttribute("open", true);
         item.querySelector("ul").addEventListener("mouseleave", () => {
           item.removeAttribute("open");
         });
         item.addEventListener("mouseleave", () => {
           item.removeAttribute("open");
         });
       });
      });
  }

   var parentSwiper = new Swiper('.cstm_product_swiper', {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 20,
      loop: false,
      autoHeight: true,
      pagination:{
         el: '.cstm_product_swiper .swiper-pagination',
         clickable:true
       },
      navigation:{
        nextEl: '.cstm_product_swiper .swiper-button-next',
        prevEl: '.cstm_product_swiper .swiper-button-prev'
      },
      breakpoints:{
        0: {
          navigation: false,
        },
        750: {
          pagination: false
         }
       }
    });

// accordian js || faq page start
function faq_taggle() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    const scrollcontent = accordion.getAttribute("js-acc-single-trigger-scroll") || null;
    content.style.maxHeight = 'max-content';
  };
  
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    const menus = accordion.querySelectorAll(".accordaian-head-block .menu_list")
    menus.forEach(function(menu) {
      menu.addEventListener('click',function(target) {
        accordion.classList.remove("active");
        if(content){
          content.style.maxHeight = null;
        }
      })
    })
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };


  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    const acc_main = accordion.closest('[data-tab-acc-main-content]') || null;
    if(intro){
        intro.onclick = (e) => {
          if (content.style.maxHeight) {
            closeAccordion(accordion);
          } else {
            if(acc_main){
              const main_accodin = acc_main.querySelectorAll("[js-acc-item]");
              main_accodin.forEach((accordion) => closeAccordion(accordion));
               openAccordion(e.target.closest('[js-acc-item]'));
            }else{
               accordions.forEach((accordion) => closeAccordion(accordion));
               openAccordion(e.target.closest('[js-acc-item]'));
            }
            
          }
        };
    }
  });   
}


// accordian js || faq page  End



// faq desktop
document.addEventListener("DOMContentLoaded", function() {
  var navigation = document.querySelectorAll(".faq-scroll-tab a");

  navigation.forEach(function(anchor) {
    anchor.addEventListener("click", function(event) {
      event.preventDefault(); // Prevent default anchor behavior

      // Remove 'active' class from all anchors
      navigation.forEach(function(nav) {
        nav.classList.remove("active");
      });

      // Add 'active' class to the clicked anchor
      this.classList.add("active");

      // Smooth scroll to the target
      smoothScroll(this.hash);
    });
  });
});

// faq page mobile
document.addEventListener("DOMContentLoaded", function() {
  var navigation = document.querySelector(".acc_tab-inner .acc-tab-titles ul");

  if (navigation) {
    navigation.addEventListener("click", function(event) {
      const target = event.target.closest('a');
      console.log("target",target);
      // Ensures the event is for an anchor tag within the list
      if (target.tagName.toLowerCase() === 'a') {
        event.preventDefault(); // Prevents previous event

        // Removes the 'active-accor' and 'active_li' classes from all items
        document.querySelectorAll(".acc_tab-inner .acc-tab-titles ul li > a").forEach(link => {
          console.log("link",link);
          link.classList.remove('active-accor');
        });
        document.querySelectorAll(".acc_tab-inner .acc-tab-titles ul li").forEach(item => {
          item.classList.remove('active_li');
        });

        // Adds the 'active-accor' and 'active_li' classes to the clicked item
        target.classList.add('active-accor');
        target.closest('li').classList.add('active_li');

        // Updates the text of the selected category
        const mainHeadText = target.querySelector('.main-head-text');
        if (mainHeadText) {
          document.querySelector('.acc-categories-selected').textContent = mainHeadText.textContent;
        }

        // Scrolls smoothly to the target hash element
        smoothScroll(target.hash);
      }
    });
  }
});


function smoothScroll(targetId) {
  var targetElement = document.querySelector(targetId);
  if (targetElement) {
    var headerHeight = document.querySelector('.sticky-header') ? document.querySelector('.sticky-header').offsetHeight + 10 : 150;
    
    window.scrollTo({
      top: targetElement.getBoundingClientRect().top + window.scrollY - headerHeight,
      behavior: 'smooth'
    });
  }
}


//  custom bundal code end
// function custom_addtocart_fun(product,open_drawer){
//       fetch(`${routes.cart_add_url}`,{ 
//               method: 'POST',
//               headers: { "Accept": "application/json", "Content-Type": "application/json" },
//               body: JSON.stringify(product)
//         })
//         .then(response => response.json()).then(response => {     
//           // console.log(response);   
//         })
//         .catch((error) => {
//           console.error('Error:', error);
//         })
//         .finally((e) => {
//           // console.log("finally");
//           if(open_drawer){
//             const this_cartDrawer = document.querySelector('cart-drawer');
//             this_cartDrawer.refresh(true);
//           }
//         });
// }



(function() {
  faq_taggle();
})();

//tab_hover_producy home page 
if (screen.width < 899) {
  var hidden_divs = document.querySelectorAll(".more_then_4");
  if(hidden_divs){
   hidden_divs.forEach(function(hidden_div) {
     hidden_div.classList.add("hidden");
    }); 
  }    
}

// bundle pdp
function custom_addtocart_fun(product,open_drawer){
  // console.log("function called");
      fetch(`${routes.cart_add_url}`,{ 
              method: 'POST',
              headers: { "Accept": "application/json", "Content-Type": "application/json" },
              body: JSON.stringify(product)
        })
        .then(response => response.json()).then(response => {              
          // console.log(response);   
        })
        .catch((error) => {
          console.error('Error:', error);
        })
        .finally((e) => {
          if(open_drawer){
            const this_cartDrawer = document.querySelector('cart-drawer');
            this_cartDrawer.refresh(true);
          }
        });
}

// globo option app to image change PDP
function ALAcheckCatorgy() { 
isALARenderedCategory = setInterval(function () {
  const checkele = document.querySelector(".gpo-app") || null;
  if(checkele){
      clearInterval(isALARenderedCategory);
      gpoData();   
  }
  }, 2000); 
 } 
ALAcheckCatorgy(); 

function gpoData() {
    const radioButtons = document.querySelectorAll('input[type="radio"][name="Grillgroesse"]');
  if(radioButtons){
    radioButtons.forEach((radio) => {    
      radio.addEventListener("click", function () {  
         const main_pdp_slider = document.querySelector('[data-main-pdp-swiper]') || null
         if(!main_pdp_slider) return;
           const main_con_pdp = main_pdp_slider.swiper || false
           const gpo_swiper = radio.value ;
           const altMedia = document.querySelector('.pdp_slider_cover [data-media-alt= "'+ gpo_swiper +'" ]') || null;   
            if(main_con_pdp && altMedia){
              main_con_pdp.slideTo(altMedia.getAttribute('data-swiper-slide-id'),1000,false);
            }         
      });
    });
  }
}


const popup_open = document.querySelectorAll('[data-popup-open]') || null;
  if(popup_open){
      popup_open.forEach(b => {
      b.addEventListener("click", (event) => {
        event.preventDefault();
           const main_popup = document.querySelector(event.target.hash) || null;
        console.log(main_popup);
          if(!main_popup) return;
                 main_popup.classList.add("open"); 
                 document.body.classList.add("popup_open");
        });
     });
  }  

  const popup_close = document.querySelectorAll('[data-popup-close]') || null;

  if(popup_close){
      popup_close.forEach(b => {
      b.addEventListener("click", (event) => {
        event.preventDefault();
           const main_popup = event.target.closest('[data-poup]') || null;

          if(!main_popup) return;
                 main_popup.classList.remove("open"); 
                 document.body.classList.remove("popup_open");
        });
     });
  } 



document.addEventListener("DOMContentLoaded", function () {
  const playButtons = document.querySelectorAll(".custom_play_btn");

  playButtons.forEach((playBtn) => {
    playBtn.addEventListener("click", function () {
      const targetId = this.dataset.target;
      const posterId = this.dataset.poster;
      const video = document.getElementById(targetId);
      const poster = document.getElementById(posterId);

      if (video && poster) {
        // Just hide the poster and show this video only
        poster.style.display = "none";
        video.classList.remove("hidden");
        video.style.display = "block";

        // Play this video without pausing others
        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise
            .then(() => console.log("Video playing"))
            .catch((error) => console.error("Video play error:", error));
        }
      }
    });
  });
});


// ---------inquiry button click PDP---


  const inquiryBtn = document.querySelector(".inquiry_btn");
  const popup = document.querySelector(".inquiry-popup");
  const body = document.body;
  const closeBtn = document.querySelector(".inquiry-close");


  if (inquiryBtn && popup) {
    inquiryBtn.addEventListener("click", function () {
      popup.classList.add("inquiry_active");   // add class to popup
      body.classList.add("inquiry_popup_open"); // add class to body
    });
    
  }
  if (closeBtn && popup) {
      closeBtn.addEventListener("click", function () {
        popup.classList.remove("inquiry_active");
        body.classList.remove("inquiry_popup_open");
      });
    }
body.addEventListener('click', function (e) {
  // Optional safeguard: prevent removal if clicking inside popup
  if (!popup?.contains(e.target) && !e.target.classList.contains('inquiry_btn')) {
    popup?.classList.remove('inquiry_active');
    body.classList.remove('inquiry_popup_open');
  }
});


// custom option value set in contact form
// https://schwengo-shop.shop/products/schweng-outdoor-vorhang

const contact_form = document.querySelector("#ContactForm");
const inquiry_click = document.querySelector(".inquiry_btn");

inquiry_click.addEventListener('click', function (e) {
  const parent = inquiry_click.closest("section");
  const form = parent?.querySelector("product-info product-form form");
  const formData = new FormData(form);
  const dataObject = Object.fromEntries(formData);

  contact_form.querySelectorAll(".product-hidden-field").forEach(el => el.remove());

  Object.entries(dataObject).forEach(([key, value]) => {    
    if (key.includes("properties") && value ) {
      const inputEl = document.querySelector(`input[name="${key}"]`);
      const image_value = inputEl?.closest('label')?.querySelector('img')?.getAttribute('src') || value;
      const cleanKey = key.replace(/^properties\[(.+)\]$/, "$1");
      const hiddenInput = document.createElement("input");
        hiddenInput.type = "hidden";
        hiddenInput.name = `contact[${cleanKey}]`;
        hiddenInput.value = image_value;
        hiddenInput.classList.add("product-hidden-field"); 
        contact_form.appendChild(hiddenInput);
    }    
  });
});

// async function syncGiftWithMain() {
//   async function getCartData() {
//     try {
//       const res = await fetch(`${routes.cart_url}.js`);
//       if (!res.ok) throw new Error(`HTTP error! ${res.status}`);

//       const cartData = await res.json();

//       // 1️⃣ Find main product with _current_time
//       const mainProduct = cartData.items.find(i => i.properties?._current_time);
//       if (!mainProduct) return;

//       const ts = mainProduct.properties._current_time;

//       const giftProduct = cartData.items.find(i =>
//         i.properties?._current_time === ts &&
//         i.id !== mainProduct.id
//       );

//       // 3️⃣ Gift logic     
//       if (giftProduct.quantity !== mainProduct.quantity) {
//         console.log("🔄 Updating gift quantity...");
//         updateGiftProductQuantity(giftProduct.key, mainProduct.quantity);
//         console.log("giftProduct.key",giftProduct,"mainProduct.quantity",mainProduct.quantity) ;
//         return;
//       }

//       // 4️⃣ If main product is removed, remove gift too
//       const mainStillInCart = cartData.items.some(i =>
//         i.id === mainProduct.id
//       );

//       if (!mainStillInCart && giftProduct) {
//         console.log("🗑 Removing gift since main product is gone...");
//         removeGiftProduct(giftProduct.key);
//       }

//     } catch (error) {
//       console.error('❌ Error fetching cart data:', error);
//     }
//   }


//   function updateGiftProductQuantity(itemKey, newQty) {
//     fetch(`${routes.cart_url}.js`, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ id: itemKey, quantity: newQty })
//     }).then(res => res.json())
//       .then(data => console.log("Gift quantity updated:", data))
//       .catch(err => console.error("Update error:", err));
//   }

//   function removeGiftProduct(itemKey) {
//     fetch(`${routes.cart_url}.js`, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ id: itemKey, quantity: 0 })
//     }).then(res => res.json())
//       .then(data => console.log("Gift removed:", data))
//       .catch(err => console.error("Remove error:", err));
//   }

//   // Run it
//   getCartData();
// }

